<script>
  export let name
  export let value
  export let position
</script>

<div
  class="root"
  data-name={name}
  data-value={value}
  data-position={position}
  style="--position: {position};"
/>

<style>
  .root {
    position: absolute;
    z-index: 0;

    height: 1px;
    width: 100%;

    bottom: calc(100% * (var(--position)));

    background-color: var(--grey);
  }

  .root::before,
  .root::after {
    font-family: var(--font-family);
    font-size: var(--font-size-s);
    line-height: var(--font-size-s);
    position: absolute;
    top: 4px;
    color: var(--grey);
  }

  .root::before {
    content: attr(data-name);
    left: 0;
  }

  .root::after {
    right: 0;
    content: attr(data-value);
  }
</style>
